var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"uk-padding-top"},[_c('div',{staticClass:"uk-margin-top footer"},[_vm._v(" All rights reserved | DNZ-PROJECTS © "+_vm._s(new Date().getFullYear())+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }